class CollapsableGroup {
  constructor(container) {
    this.container = container
    this.items = []
    this._registerItems()
  }

  _registerItems() {
    this.container.querySelectorAll("[data-collapsable]").forEach((el) => {
      const item = {
        el,
        trigger: el.querySelector("[data-collapsable-trigger]"),
        panel: el.querySelector("[data-collapsable-panel]"),
        icon: el.querySelector("[data-collapsable-icon]"),
        subtitle: el.querySelector("[data-collapsable-subtitle]"),
      }
      this.items.push(item)
      if (!el.hasAttribute("data-collapsable-disabled")) {
        item.trigger.addEventListener("click", () => this._onTrigger(item))
      }
    })
  }

  _onTrigger(item) {
    const isOpen = !item.panel.classList.contains("hidden")
    this._closeAll()
    if (!isOpen) this._open(item)
  }

  _open(item) {
    item.panel.classList.remove("hidden")
    item.icon.textContent = "−"
  }

  _close(item) {
    item.panel.classList.add("hidden")
    item.icon.textContent = "+"
  }

  _closeAll() {
    this.items.forEach((item) => this._close(item))
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-collapsable-group]").forEach((container) => {
    new CollapsableGroup(container)
  })
})
